import api from 'api';

export const CURRENT_STATS_ASYNC_ACTION_START = 'CURRENT_STATS_ASYNC_ACTION_START';
export const CURRENT_STATS_ASYNC_ACTION_ERROR = 'CURRENT_STATS_ASYNC_ACTION_ERROR';
export const CURRENT_STATS_ASYNC_UPDATE_SUCCESS = 'CURRENT_STATS_ASYNC_UPDATE_SUCCESS';
export const CURRENT_STATS_UPDATE_SUCCESS = 'CURRENT_STATS_UPDATE_SUCCESS';
export const CURRENT_STATS_RESET_STATE = 'CURRENT_STATS_RESET_STATE';


function currentStatsAsyncStart() {
  return {
    type: CURRENT_STATS_ASYNC_ACTION_START,
  };
}

function currentStatsAsyncUpdateSuccess(data) {
  return {
    type: CURRENT_STATS_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function currentStatsAsyncError(error) {
  return {
    type: CURRENT_STATS_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetCurrentStatsState() {
  return {
    type: CURRENT_STATS_RESET_STATE,
  };
}

export function updateCurrentStats(data) {
  return {
    type: CURRENT_STATS_UPDATE_SUCCESS,
    data,
  };
}

export function getCurrentStatsAsync(accountId) {
  return (dispatch, getState) => {
    dispatch(currentStatsAsyncStart());
    return api.request(`assets/count?accountId=${accountId}`, 'get')
    .then((data) => {
      dispatch(currentStatsAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(currentStatsAsyncError('Unable to get current stats'));
      throw (err);
    });
  };
}